import { RMSProjectsBlockModel } from './RMSProjectsBlockModel'
import styles from './RMSProjectsBlock.module.scss'
import multipleClassName from '../../../../utils/multipleClassName'
import transformToReactStyle, {
  transformToReactMaxWidthContainerStyle,
} from '../../components/elements/rms-css-style-block/transformToReactStyle'
import transformToReactContainerClasses from '../../components/elements/rms-css-style-block/transformToReactClasses'
import { motion } from 'framer-motion'
import { configOpacityScale } from '../../animations/framer-motion/motion-configs'
import RMSProjectsSmall from '../../../../features/rms-projects/features/projects/components/rms-project-small/RMSProjectsSmall'
import RMSTechnologyShort from '../../../../features/rms-projects/features/technologies/components/rms-technology-short/RMSTechnologyShort'

export default function RMSProjectsBlock({
  blockElement,
}: {
  blockElement: RMSProjectsBlockModel
}) {
  const data = blockElement.value

  return (
    <div
      className={multipleClassName(
        styles.RMSProjectsBlock,
        'IgnoreMaxWidth',
        'MaxWidthOuterContainer',
      )}
      style={transformToReactStyle(blockElement.value.css_style)}
    >
      <div
        className={multipleClassName(
          styles.inner,
          'MaxWidthContainer',
          transformToReactContainerClasses(blockElement.value.css_style),
        )}
        style={transformToReactMaxWidthContainerStyle(
          blockElement.value.css_style,
        )}
      >
        <motion.div {...configOpacityScale} className={styles.header}>
          {data.title && <h2>{data.title}</h2>}
          {data.subtitle && <h3>{data.subtitle}</h3>}
        </motion.div>
        <div className={styles.content}>
          {data.projects &&
            data.projects.map((project, index) => {
              return <RMSProjectsSmall key={index} project={project} />
            })}
        </div>
      </div>
    </div>
  )
}
